// Vuetify
import "vuetify/styles";
// Material Design Icons
import "@mdi/font/css/materialdesignicons.css";
// Global styles
import "./assets/main.scss";

import { createPinia } from "pinia";
import { createApp } from "vue";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

import App from "./App.vue";
import {
  VueQueryPlugin,
  vueQueryPluginOptions,
} from "./plugins/vueQuery";
import router from "./router";

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: "mdi",
  },
  theme: {
    defaultTheme: "practiceRoom",
    themes: {
      practiceRoom: {
        dark: true,
        colors: {
          background: "#1a1714",
          surface: "#2a2520",
          "surface-variant": "#332e28",
          "on-surface-variant": "#e8e0d8",
          primary: "#d4a574",
          secondary: "#7a9a8a",
          accent: "#c8956c",
          error: "#cf6679",
          info: "#7a9a8a",
          success: "#81b29a",
          warning: "#e0a458",
          // Review identity color. A light dusty lavender chosen to read
          // clearly on the dark warm palette — including as `variant="tonal"`,
          // where the text uses this color over a low-opacity tint of it.
          anki: "#b8a4dc",
          review: "#b8a4dc",
          "on-background": "#e8e0d8",
          "on-surface": "#e8e0d8",
          "on-primary": "#1a1714",
          "on-secondary": "#1a1714",
          "on-error": "#1a1714",
          "on-success": "#1a1714",
          "on-warning": "#1a1714",
          "on-info": "#1a1714",
          "on-anki": "#241d30",
          "on-review": "#241d30",
        },
      },
    },
  },
  defaults: {
    VCard: {
      rounded: "lg",
      flat: true,
      color: "surface",
    },
    VBtn: {
      rounded: "lg",
    },
    VChip: {
      rounded: "pill",
    },
    VTextField: {
      variant: "outlined",
      density: "comfortable",
      color: "primary",
    },
    VTextarea: {
      variant: "outlined",
      density: "comfortable",
      color: "primary",
    },
    VSelect: {
      variant: "outlined",
      density: "comfortable",
      color: "primary",
    },
    VAutocomplete: {
      variant: "outlined",
      density: "comfortable",
      color: "primary",
    },
    VCombobox: {
      variant: "outlined",
      density: "comfortable",
      color: "primary",
    },
    VProgressLinear: {
      rounded: true,
      color: "primary",
      bgColor: "surface-variant",
    },
    VProgressCircular: {
      color: "primary",
    },
    VDialog: {
      maxWidth: 600,
    },
    VDataTable: {
      hover: true,
    },
  },
});

const app = createApp(App);

app.use(createPinia());
app.use(VueQueryPlugin, vueQueryPluginOptions);
app.use(router);
app.use(vuetify);

app.mount("#app");
